module.exports = __webpack_public_path__ + "media/images/icon_sort-272882e399382cd58242313db5f7c491.png";